"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFegoPageInfo = useFegoPageInfo;
const vue_demi_1 = require("vue-demi");
const webapi_1 = require("@fegobull/webapi");
function useFegoPageInfo() {
    const { useLang, usePageType } = webapi_1.use;
    const { langText } = useLang();
    const { isPC } = usePageType();
    /** 英文 */
    const isEN = (0, vue_demi_1.computed)(() => langText === 'en-us');
    /** 繁体中文 */
    const isHant = (0, vue_demi_1.computed)(() => langText === 'zh-hk');
    /** 简体中文 */
    const isHans = (0, vue_demi_1.computed)(() => langText === 'zh-cn');
    const kls = (0, vue_demi_1.computed)(() => [
        isPC ? 'is-pc' : 'is-mobile',
        isEN.value ? 'is-en' : '',
        isHant.value ? 'is-hant' : '',
        isHans.value ? 'is-hans' : '',
    ]);
    return {
        kls,
        isPC,
        isEN,
        isHant,
        isHans,
    };
}
